var render = function () {
  var _vm$user, _vm$user2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return (_vm$user = _vm.user) !== null && _vm$user !== void 0 && _vm$user._id ? _c('v-sheet', [_c('qrcode-vue', {
    staticClass: "d-flex justify-center pa-7",
    attrs: {
      "value": (_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : _vm$user2._id,
      "size": 178
    }
  }), _c('v-divider'), _c('v-card-text', {
    staticClass: "pa-4"
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "font-weight-bold",
    attrs: {
      "cols": "auto",
      "sm": "3"
    }
  }, [_vm._v("이름")]), _c('v-col', [_vm._v(_vm._s(_vm.user.name))])], 1), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "font-weight-bold",
    attrs: {
      "cols": "auto",
      "sm": "3"
    }
  }, [_vm._v("회원번호")]), _c('v-col', [_vm._v(_vm._s(_vm.user._id))])], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }